import React, {Component} from 'react';
import PropTypes from "prop-types";

import { withTranslation } from "react-i18next";


class FileStatusCellRender extends Component {
  

  renderSwitch(param) {
    let returnClass='';
    switch(param) {
      case 'Pending':
        returnClass='primary';break;
      case 'Inprogress':
        returnClass='warning';break;      
      case 'Fail':
        returnClass='danger';break;      
      case 'Cancel':
        returnClass='secondary';break;              
      default:
        returnClass='secondary';break;  
    }
    return <span className={"badge bg-"+returnClass}> {param}</span>
  }

  render() {
    return (
      this.renderSwitch(this.props.value)
    )
  }
}

FileStatusCellRender.propTypes = {
  value: PropTypes.any,
};

export default (withTranslation()(FileStatusCellRender));